import { useCallback } from 'react';
import { useAppHeader } from 'AppHeaderReact';
import { type StreamForStreamDashboard } from 'Lessons';

/*
    The bookmark flag and its toggle. The flag lives in the header store, so this page and the header agree.
    Before useStreamDashboardHeader seeds the store, fall back to the payload.
*/
export function useStreamBookmark(stream: StreamForStreamDashboard) {
    const { viewedStream, toggleBookmark } = useAppHeader();

    return {
        favorite: viewedStream?.favorite ?? stream.favorite,
        toggleBookmark: useCallback(() => {
            if (viewedStream) toggleBookmark(viewedStream);
        }, [toggleBookmark, viewedStream]),
    };
}
